import React, { ReactNode } from 'react';
import { isHasAccess } from 'features/validateAccess';
import { pathKeys } from 'shared/lib/react-router';
import { ProtectedLink } from 'shared/ui/ProtectedLink';

import styles from '../DemandWidget.module.scss';
import { getDemandWidgetItemLinkPermissions } from '../DemandWidget.permissions';
import { DataType } from '../DemandWidget.types';

const RowWrapper = (children: ReactNode, { accountId, projectId }: DataType): ReactNode => {
  const showLink = isHasAccess(getDemandWidgetItemLinkPermissions(accountId, projectId));

  return (
    <ProtectedLink
      hasAccess={showLink}
      to={pathKeys.position.root({ accountId, projectId })}
      className={styles.rowWrapper}
    >
      {children}
    </ProtectedLink>
  );
};

const DemandRowWrapper = (children: ReactNode, record: DataType): ReactNode => {
  if (record) {
    return RowWrapper(children, record);
  }
  return <div className={styles.rowWrapper}>{children}</div>;
};

export default DemandRowWrapper;
